import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { typeEstruturaCompraInsumos, typeInsumos } from './index';
import { HeaderDef } from './gerarPDFCompraInsumos';
import { logo_ttivos_base64 } from '../../../../../../../Components/GerarExcel/meta';
import secureLocalStorage from "react-secure-storage";

export const gerarExcelCompraInsumos = async (
    dados: (typeEstruturaCompraInsumos | typeInsumos)[],
    headerInfo?: HeaderDef
) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Compra de Insumos', {
        views: [{ showGridLines: false }]
    });

    worksheet.columns = [
        { header: '', key: 'col1', width: 25 },
        { header: '', key: 'col2', width: 25 },
        { header: '', key: 'col3', width: 20 },
        { header: '', key: 'col4', width: 20 },
        { header: '', key: 'col5', width: 20 },
        { header: '', key: 'col6', width: 20 },
    ];

    let currentRow = 1;

    // ** HEADER **
    worksheet.getRow(currentRow).height = 40; // Linha para a imagem
    worksheet.getRow(currentRow + 1).height = 30; // Linha para o título
    worksheet.getRow(currentRow + 2).height = 20; // Linha para razao social

    // LOGO
    const headerImageId = workbook.addImage({
        base64: logo_ttivos_base64,
        extension: 'png',
    });

    worksheet.addImage(headerImageId, {
        tl: { col: 2.2, row: 0 },
        ext: { width: 121, height: 50 },
        editAs: 'LOGO TTIVOS'
    });
    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const logoRow = worksheet.getRow(currentRow);
    logoRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    for (let i = 1; i <= 6; i++) {
        logoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const titleRow = worksheet.getRow(currentRow);
    titleRow.getCell(1).value = headerInfo?.titulo || 'Relatório de Compra de Insumos';
    titleRow.getCell(1).font = { size: 16, bold: true };
    titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 6; i++) {
        titleRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const razaoRow = worksheet.getRow(currentRow);
    razaoRow.getCell(1).value = headerInfo?.razaoSocial || '';
    razaoRow.getCell(1).font = { size: 10 };
    razaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 6; i++) {
        razaoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    // ** CLIENTE, SAFRA, CULTURA **
    if (headerInfo?.cliente) {
        worksheet.getRow(currentRow).height = 10; // Espaçamento superior
        currentRow++;

        // --- ROW DE RÓTULOS (Labels) ---
        worksheet.getRow(currentRow).height = 15;
        worksheet.mergeCells(`A${currentRow}:B${currentRow}`);
        worksheet.mergeCells(`C${currentRow}:D${currentRow}`);
        worksheet.mergeCells(`E${currentRow}:F${currentRow}`);

        const labelRow = worksheet.getRow(currentRow);
        
        labelRow.getCell(1).value = 'CLIENTE';
        labelRow.getCell(3).value = 'SAFRA';
        labelRow.getCell(5).value = 'CULTURA';

        const labelFont = { size: 9, bold: true, color: { argb: 'FF7B7B7B' } };
        const centerAlignment = { horizontal: 'center', vertical: 'middle' } as const;

        labelRow.getCell(1).font = labelFont;
        labelRow.getCell(3).font = labelFont;
        labelRow.getCell(5).font = labelFont;

        labelRow.getCell(1).alignment = centerAlignment;
        labelRow.getCell(3).alignment = centerAlignment;
        labelRow.getCell(5).alignment = centerAlignment;

        currentRow++;

        // --- ROW DE VALORES ---
        worksheet.getRow(currentRow).height = 20;
        worksheet.mergeCells(`A${currentRow}:B${currentRow}`);
        worksheet.mergeCells(`C${currentRow}:D${currentRow}`);
        worksheet.mergeCells(`E${currentRow}:F${currentRow}`);

        const valueRow = worksheet.getRow(currentRow);
        
        valueRow.getCell(1).value = (headerInfo.cliente || '-').toUpperCase();
        valueRow.getCell(3).value = (headerInfo.safra || '-').toUpperCase();
        valueRow.getCell(5).value = (headerInfo.cultura || '-').toUpperCase();

        const valueFont = { size: 11, bold: true, color: { argb: 'FF000000' } };

        valueRow.getCell(1).font = valueFont;
        valueRow.getCell(3).font = valueFont;
        valueRow.getCell(5).font = valueFont;

        valueRow.getCell(1).alignment = centerAlignment;
        valueRow.getCell(3).alignment = centerAlignment;
        valueRow.getCell(5).alignment = centerAlignment;

        // Adiciona bordas ao redor da nossa tabela de dados
        const borderStyle: ExcelJS.Border = { style: 'thin', color: { argb: 'FF7B7B7B' } };
        
        const labelRowNumber = currentRow - 1;
        const valueRowNumber = currentRow;

        for (let col = 1; col <= 6; col++) {
            worksheet.getRow(labelRowNumber).getCell(col).border = {
                top: borderStyle,
                left: col === 1 || col === 3 || col === 5 ? borderStyle : undefined,
                right: col === 2 || col === 4 || col === 6 ? borderStyle : undefined,
            };
            worksheet.getRow(valueRowNumber).getCell(col).border = {
                bottom: borderStyle,
                left: col === 1 || col === 3 || col === 5 ? borderStyle : undefined,
                right: col === 2 || col === 4 || col === 6 ? borderStyle : undefined,
            };
        }

        currentRow++;
    }

    currentRow++; // linha vazia

    const applyBorders = (rowNum: number, color = 'FF000000', colCount = 6) => {
        const row = worksheet.getRow(rowNum);
        for (let i = 1; i <= colCount; i++) {
            row.getCell(i).border = {
                top: { style: 'thin', color: { argb: color } },
                left: { style: 'thin', color: { argb: color } },
                bottom: { style: 'thin', color: { argb: color } },
                right: { style: 'thin', color: { argb: color } }
            };
        }
    };

    const isJuntarInsumos = dados.length > 0 && !('insumos' in dados[0]);

    if (isJuntarInsumos) {
        const colHeaderRow = worksheet.getRow(currentRow);
        
        worksheet.mergeCells(`A${currentRow}:C${currentRow}`);
        const cellInsu = colHeaderRow.getCell(1);
        cellInsu.value = 'Insumo';
        cellInsu.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cellInsu.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
        cellInsu.alignment = { horizontal: 'center', vertical: 'middle' };

        worksheet.mergeCells(`D${currentRow}:F${currentRow}`);
        const cellQuant = colHeaderRow.getCell(4);
        cellQuant.value = 'Quantidade';
        cellQuant.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cellQuant.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
        cellQuant.alignment = { horizontal: 'center', vertical: 'middle' };

        for (let i = 1; i <= 6; i++) {
            if (i !== 1 && i !== 4) {
                colHeaderRow.getCell(i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
            }
        }

        colHeaderRow.height = 20;
        applyBorders(currentRow, 'FF000000');
        currentRow++;

        let globalInsumoIndex = 0;

        (dados as typeInsumos[]).forEach((insu) => {
            const zebraColor = (globalInsumoIndex % 2 === 0) ? 'FFFFFFFF' : 'FFE5F1E1';

            worksheet.mergeCells(`A${currentRow}:C${currentRow}`);
            const insuRow = worksheet.getRow(currentRow);
            insuRow.getCell(1).value = insu.insumo_nome || '-';

            worksheet.mergeCells(`D${currentRow}:F${currentRow}`);
            insuRow.getCell(4).value = insu.quantidade_total_view || '-';

            insuRow.height = 20;

            for (let i = 1; i <= 6; i++) {
                const cell = insuRow.getCell(i);
                cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
            }

            applyBorders(currentRow, 'FF000000');
            currentRow++;
            globalInsumoIndex++;
        });

        if (dados.length === 0) {
            worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
            const emptyRow = worksheet.getRow(currentRow);
            emptyRow.getCell(1).value = 'Nenhum insumo planejado.';
            emptyRow.getCell(1).font = { italic: true };
            emptyRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            emptyRow.height = 25;
            applyBorders(currentRow, 'FF000000');
            currentRow++;
        }

    } else {
        (dados as typeEstruturaCompraInsumos[]).forEach((propriedade) => {
            worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
            const propRow = worksheet.getRow(currentRow);
            propRow.getCell(1).value = propriedade.nome_propriedade || "PROPRIEDADE NÃO INFORMADA";
            propRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
            propRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF5DA57D' } };
            propRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            propRow.height = 25;
            applyBorders(currentRow, 'FF165C13');
            currentRow++;

            const colHeaderRow = worksheet.getRow(currentRow);
            
            worksheet.mergeCells(`A${currentRow}:C${currentRow}`);
            const cellInsu = colHeaderRow.getCell(1);
            cellInsu.value = 'Insumo';
            cellInsu.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cellInsu.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
            cellInsu.alignment = { horizontal: 'center', vertical: 'middle' };

            worksheet.mergeCells(`D${currentRow}:F${currentRow}`);
            const cellQuant = colHeaderRow.getCell(4);
            cellQuant.value = 'Quantidade';
            cellQuant.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cellQuant.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
            cellQuant.alignment = { horizontal: 'center', vertical: 'middle' };

            for (let i = 1; i <= 6; i++) {
                if (i !== 1 && i !== 4) {
                    colHeaderRow.getCell(i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
                }
            }

            colHeaderRow.height = 20;
            applyBorders(currentRow, 'FF000000');
            currentRow++;

            let globalInsumoIndex = 0;

            propriedade.insumos.forEach((insu) => {
                const zebraColor = (globalInsumoIndex % 2 === 0) ? 'FFFFFFFF' : 'FFE5F1E1';

                worksheet.mergeCells(`A${currentRow}:C${currentRow}`);
                const insuRow = worksheet.getRow(currentRow);
                insuRow.getCell(1).value = insu.insumo_nome || '-';

                worksheet.mergeCells(`D${currentRow}:F${currentRow}`);
                insuRow.getCell(4).value = insu.quantidade_total_view || '-';

                insuRow.height = 20;

                for (let i = 1; i <= 6; i++) {
                    const cell = insuRow.getCell(i);
                    cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                }

                applyBorders(currentRow, 'FF000000');
                currentRow++;
                globalInsumoIndex++;
            });

            if (propriedade.insumos.length === 0) {
                worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                const emptyRow = worksheet.getRow(currentRow);
                emptyRow.getCell(1).value = 'Nenhum insumo planejado para esta propriedade.';
                emptyRow.getCell(1).font = { italic: true };
                emptyRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                emptyRow.height = 25;
                applyBorders(currentRow, 'FF000000');
                currentRow++;
            }

            currentRow++; // empty space between propriedades
        });
    }

    // ** FOOTER **
    const espacoRow = worksheet.addRow([]);
    espacoRow.height = 20;

    const email_usuario_logado = (secureLocalStorage.getItem('Itens') as any)?.[0]?.email?.toLowerCase() || '';
    const footerRow = worksheet.addRow([]);
    footerRow.getCell(1).value = `Gerado por: ${email_usuario_logado} - ${dayjs().format('DD/MM/YYYY HH:mm:ss')}`;
    footerRow.font = { italic: true };
    footerRow.alignment = { horizontal: 'center', vertical: 'middle' };

    for (let i = 1; i <= 6; i++) {
        worksheet.getCell(`${String.fromCharCode(64 + i)}${footerRow.number}`).border = {
            top: { style: 'thin', color: { argb: 'FF5DA57D' } }
        };
    }
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    footerRow.height = 25;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `Relatorio_Compra_Insumos_${dayjs().format("DD_MM_YYYY_HH_mm")}.xlsx`);
};
